export default class ProxyDistanciaModel {
  public origem: string = "";
  public destino: string = "";
  public distancia: number = 0;
  public lojaId: string = "";

  public static toModel(item: any): ProxyDistanciaModel {
    return {
      lojaId: item.lojaId,
      origem: item.origem,
      destino: item.destino,
      distancia: item.distancia
    } as ProxyDistanciaModel;
  }
}